let header = document.getElementById("header");
let logo = document.getElementById("logo");
let logoLink = document.getElementById("logo-link");
let mainMenuToggle = document.getElementById("main-menu-toggle");
let leftMenu = document.getElementById("menu-header-main-menu-1");
let menuBtn = document.getElementsByClassName("menu-left__btn");
let menuLink = document.getElementsByClassName("menu-left__link");
let subMenu = document.getElementsByClassName("menu-left__submenu");
let submenuLvlTwo = document.getElementsByClassName("menu-left__btn--level-2");
let containerMenuLeft = document.getElementsByClassName("header__menu");
let backMenuBtn = document.getElementsByClassName("back-menu__btn");
let skipLink = document.getElementById("skip-link");
let mainMenuContainer = document.getElementById("main-menu");

for (let i = 0; i < menuBtn.length; i++) {
  menuBtn[i].addEventListener("click", function () {
    // Check button current state.
    let isOpen = this.getAttribute("aria-expanded") === "true";

    // Close other submenus.
    Array.from(subMenu).forEach((el) => {
      el.classList.remove("menu-left__submenu--open");
    });

    // Set expanded false for other menu buttons.
    Array.from(menuBtn).forEach((el) => {
      el.setAttribute("aria-expanded", "false");
      el.classList.remove("menu-left__btn--expanded");
    });

    mainMenuToggle.classList.add("menu-toggle--submenu");

    if (isOpen) {
      // Close submenu
      this.nextElementSibling.classList.remove("menu-left__submenu--open");
      this.setAttribute("aria-expanded", "false");
      this.classList.remove("menu-left__btn--expanded");
      // Class for mobile.
      header.classList.remove("header--purple");
      mainMenuContainer.classList.remove("menu-container--purple");
      logo.classList.remove("logo__img--white");
    } else {
      // Open submenu.
      this.nextElementSibling.classList.add("menu-left__submenu--open");
      this.setAttribute("aria-expanded", "true");
      this.classList.add("menu-left__btn--expanded");
      // Class for mobile.
      header.classList.add("header--purple");
      mainMenuContainer.classList.add("menu-container--purple");
      logo.classList.add("logo__img--white");

      // Move focus to back button on mobile devices.
      if (window.innerWidth < 992) {
        this.style.visibility = "hidden";
        if (this.nextElementSibling.firstElementChild.firstElementChild.classList.contains("back-menu__btn")) {
          this.nextElementSibling.firstElementChild.firstElementChild.focus();
        }
      }
    }
  });

  menuBtn[i].addEventListener("focus", function () {
    if (window.getComputedStyle(containerMenuLeft[0]).display !== "none") {
      closeLeftMenuSubmenus();
    }
  });
}
for (let i = 0; i < menuLink.length; i++) {
  menuLink[i].addEventListener("focus", function () {
    if (window.getComputedStyle(containerMenuLeft[0]).display !== "none") {
      closeLeftMenuSubmenus();
    }
  });
}
logoLink.addEventListener("focus", function () {
  if (window.getComputedStyle(containerMenuLeft[0]).display !== "none") {
    closeLeftMenuSubmenus();
  }
});
for (let i = 0; i < submenuLvlTwo.length; i++) {
  submenuLvlTwo[i].addEventListener("click", function () {
    this.setAttribute(
      "aria-expanded",
      this.getAttribute("aria-expanded") === "true" ? "false" : "true"
    );
    this.classList.toggle("menu-left__btn--level-2-active");
    this.nextElementSibling.classList.toggle(
      "menu-left__submenu--level-2-open"
    );
  });
}

// Close submenus using the esc key.
document.addEventListener("keyup", function (e) {
  if (e.key === "Escape") {
    closeLeftMenuSubmenus();
  }
});

/* Close menu when skip link is clicked */
skipLink.addEventListener("click", function () {
  closeLeftMenuSubmenus();
});

// Close submenus when click outside left menu.
document.addEventListener("click", function (e) {
  if (
    window.getComputedStyle(containerMenuLeft[0]).display !== "none" &&
    e.target.getAttribute("class") !== null &&
    !e.target
      .getAttribute("class")
      .split(/[ __]+/)
      .includes("menu-left")
  ) {
    closeLeftMenuSubmenus();
  }
});

mainMenuToggle.addEventListener("click", function (e) {
  closeLeftMenuSubmenus();
  mainMenuContainer.classList.remove("menu-container--purple");
  header.classList.remove("header--purple-scroll");
  Array.from(subMenu).forEach((el) => {
    el.addEventListener("scroll", function () {
      if (el.scrollTop > 20) {
        header.classList.add("header--purple-scroll");
      } else {
        header.classList.remove("header--purple-scroll");
      }
    });
  });
});
for (let i = 0; i < backMenuBtn.length; i++) {
  backMenuBtn[i].addEventListener("click", function (e) {
    closeLeftMenuSubmenus();
  });
}

function closeLeftMenuSubmenus() {
  // Close all submenus.
  Array.from(subMenu).forEach((el) => {
    el.classList.remove("menu-left__submenu--open");
  });
  // Set expanded false for all menu buttons.
  Array.from(menuBtn).forEach((el) => {
    el.setAttribute("aria-expanded", "false");
    el.style.visibility = "visible";
  });
  // Remove expanded class for all menu buttons.
  Array.from(menuBtn).forEach((el) => {
    el.classList.remove("menu-left__btn--expanded");
  });

  Array.from(submenuLvlTwo).forEach((el) => {
    el.setAttribute("aria-expanded", "false");
  });

  Array.from(submenuLvlTwo).forEach((el) => {
    el.classList.remove("menu-left__btn--level-2-active");
    el.nextElementSibling.classList.remove("menu-left__submenu--level-2-open");
  });
  // Remove class header and logo used for mobile color.
  header.classList.remove("header--purple");
  mainMenuContainer.classList.remove("menu-container--purple");
  logo.classList.remove("logo__img--white");
  mainMenuToggle.classList.remove("menu-toggle--submenu");
}

// When last submenu element gets focus, move focus to close menu icon (on mobile devices).
if (window.innerWidth < 992) {
  document.addEventListener("keydown", function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      return;
    }

    // if tab key is pressed move focus to close menu icon
    if (e.target.classList.contains("menu-left__submenu-link--level-2")
        && e.target.parentElement.parentElement.lastElementChild === e.target.parentElement) {
      mainMenuToggle.focus();
      e.preventDefault();
    }
  });
}